import React from 'react'
import { Link } from 'react-router-dom'
import RecipeCard from '../components/RecipeCard'

let dummydata = {
    "recipe": {
        "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_ed552e2b04fbd836149044ac0e91b3fb",
        "label": "Broccoli Rabe",
        "image": "https://www.edamam.com/web-img/88d/88d23618c19c48e5fdc03c561eee5fe9.jpg",
        "source": "NY Magazine",
        "url": "http://nymag.com/restaurants/articles/recipes/broccolirabe.htm",
        "shareAs": "http://www.edamam.com/recipe/broccoli-rabe-ed552e2b04fbd836149044ac0e91b3fb/broccoli",
        "yield": 8.0,
        "dietLabels": [
            "High-Fiber",
            "Low-Carb"
        ],
        "healthLabels": [
            "Sugar-Conscious",
            "Keto-Friendly",
            "Vegan",
            "Vegetarian",
            "Pescatarian",
            "Paleo",
            "Dairy-Free",
            "Gluten-Free",
            "Wheat-Free",
            "Egg-Free",
            "Peanut-Free",
            "Tree-Nut-Free",
            "Soy-Free",
            "Fish-Free",
            "Shellfish-Free",
            "Pork-Free",
            "Red-Meat-Free",
            "Crustacean-Free",
            "Celery-Free",
            "Mustard-Free",
            "Sesame-Free",
            "Lupine-Free",
            "Mollusk-Free",
            "Alcohol-Free",
            "Kosher"
        ],
        "cautions": [],
        "ingredientLines": [
            "4 pounds broccoli rabe",
            "1/3 cup olive oil",
            "4 cloves garlic, coarsely chopped",
            "Salt and freshly ground black pepper"
        ],
        "ingredients": [
            {
                "text": "4 pounds broccoli rabe",
                "quantity": 4.0,
                "measure": "pound",
                "food": "broccoli rabe",
                "weight": 1814.36948
            },
            {
                "text": "1/3 cup olive oil",
                "quantity": 0.3333333432674408,
                "measure": "cup",
                "food": "olive oil",
                "weight": 72.0
            },
            {
                "text": "4 cloves garlic, coarsely chopped",
                "quantity": 4.0,
                "measure": "clove",
                "food": "garlic",
                "weight": 12.0
            },
            {
                "text": "Salt and freshly ground black pepper",
                "quantity": 0.0,
                "measure": null,
                "food": "Salt",
                "weight": 11.39021688
            },
            {
                "text": "Salt and freshly ground black pepper",
                "quantity": 0.0,
                "measure": null,
                "food": "black pepper",
                "weight": 5.69510844
            }
        ],
        "calories": 1067.8160077844002,
        "totalWeight": 1913.932236845587,
        "totalTime": "3 mins",
        "cuisineType": [
            "Mediterranean"
        ],
        "mealType": [
            "side salad",
            "dressing"
        ],
        "dishType": [
            "lunch"
        ]
    }
}

let dummydata2 = {
    "recipe": {
        "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_ed552e2b04fbd836149044ac0e91b3fb",
        "label": "Chicken Broccoli",
        "image": "https://www.dinneratthezoo.com/wp-content/uploads/2016/04/chicken-and-broccoli-stir-fry-6-2.jpg",
        "source": "NY Magazine",
        "url": "http://nymag.com/restaurants/articles/recipes/broccolirabe.htm",
        "shareAs": "http://www.edamam.com/recipe/broccoli-rabe-ed552e2b04fbd836149044ac0e91b3fb/broccoli",
        "yield": 15.0,
        "dietLabels": [
            "High-Fiber",
            "Low-Carb"
        ],
        "healthLabels": [
            "Sugar-Conscious",
            "Keto-Friendly",
            "Vegan",
            "Vegetarian",
            "Pescatarian",
            "Paleo",
            "Dairy-Free",
            "Gluten-Free",
            "Wheat-Free",
            "Egg-Free",
            "Peanut-Free",
            "Tree-Nut-Free",
            "Soy-Free",
            "Fish-Free",
            "Shellfish-Free",
            "Pork-Free",
            "Red-Meat-Free",
            "Crustacean-Free",
            "Celery-Free",
            "Mustard-Free",
            "Sesame-Free",
            "Lupine-Free",
            "Mollusk-Free",
            "Alcohol-Free",
            "Kosher"
        ],
        "cautions": [],
        "ingredientLines": [
            "4 pounds broccoli rabe",
            "1/3 cup olive oil",
            "4 cloves garlic, coarsely chopped",
            "Salt and freshly ground black pepper"
        ],
        "ingredients": [
            {
                "text": "4 pounds broccoli rabe",
                "quantity": 4.0,
                "measure": "pound",
                "food": "broccoli rabe",
                "weight": 1814.36948
            },
            {
                "text": "1/3 cup olive oil",
                "quantity": 0.3333333432674408,
                "measure": "cup",
                "food": "olive oil",
                "weight": 72.0
            },
            {
                "text": "4 cloves garlic, coarsely chopped",
                "quantity": 4.0,
                "measure": "clove",
                "food": "garlic",
                "weight": 12.0
            },
            {
                "text": "Salt and freshly ground black pepper",
                "quantity": 0.0,
                "measure": null,
                "food": "Salt",
                "weight": 11.39021688
            },
            {
                "text": "Salt and freshly ground black pepper",
                "quantity": 0.0,
                "measure": null,
                "food": "black pepper",
                "weight": 5.69510844
            }
        ],
        "calories": 1067.8160077844002,
        "totalWeight": 1913.932236845587,
        "totalTime": "20 mins",
        "cuisineType": [
            "Mediterranean"
        ],
        "mealType": [
            "side salad",
            "dressing"
        ],
        "dishType": [
            "lunch"
        ]
    }
}

let dummydata3 = {
    "recipe": {
        "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_ed552e2b04fbd836149044ac0e91b3fb",
        "label": "BBQ Ribs",
        "image": "https://cafedelites.com/wp-content/uploads/2018/06/Pork-Ribs-IMAGE-13.jpg",
        "source": "NY Magazine",
        "url": "http://nymag.com/restaurants/articles/recipes/broccolirabe.htm",
        "shareAs": "http://www.edamam.com/recipe/broccoli-rabe-ed552e2b04fbd836149044ac0e91b3fb/broccoli",
        "yield": 15.0,
        "dietLabels": [
            "High-Fiber",
            "Low-Carb"
        ],
        "healthLabels": [
            "Sugar-Conscious",
            "Keto-Friendly",
            "Vegan",
            "Vegetarian",
            "Pescatarian",
            "Paleo",
            "Dairy-Free",
            "Gluten-Free",
            "Wheat-Free",
            "Egg-Free",
            "Peanut-Free",
            "Tree-Nut-Free",
            "Soy-Free",
            "Fish-Free",
            "Shellfish-Free",
            "Pork-Free",
            "Red-Meat-Free",
            "Crustacean-Free",
            "Celery-Free",
            "Mustard-Free",
            "Sesame-Free",
            "Lupine-Free",
            "Mollusk-Free",
            "Alcohol-Free",
            "Kosher"
        ],
        "cautions": [],
        "ingredientLines": [
            "4 pounds broccoli rabe",
            "1/3 cup olive oil",
            "4 cloves garlic, coarsely chopped",
            "Salt and freshly ground black pepper"
        ],
        "ingredients": [
            {
                "text": "4 pounds broccoli rabe",
                "quantity": 21.0,
                "measure": "pound",
                "food": "broccoli rabe",
                "weight": 1814.36948
            },
            {
                "text": "1/3 cup olive oil",
                "quantity": 0.3333333432674408,
                "measure": "cup",
                "food": "olive oil",
                "weight": 72.0
            },
            {
                "text": "4 cloves garlic, coarsely chopped",
                "quantity": 4.0,
                "measure": "clove",
                "food": "garlic",
                "weight": 12.0
            },
            {
                "text": "Salt and freshly ground black pepper",
                "quantity": 0.0,
                "measure": null,
                "food": "Salt",
                "weight": 11.39021688
            },
            {
                "text": "Salt and freshly ground black pepper",
                "quantity": 0.0,
                "measure": null,
                "food": "black pepper",
                "weight": 5.69510844
            }
        ],
        "calories": 1067.8160077844002,
        "totalWeight": 1913.932236845587,
        "totalTime": "42 mins",
        "cuisineType": [
            "Mediterranean"
        ],
        "mealType": [
            "side salad",
            "dressing"
        ],
        "dishType": [
            "lunch"
        ]
    }
}

export default function Recipe(props) {
    const recipes = [
        dummydata,
        dummydata2,
        dummydata3
    ]

    return (
        <div className='Recipe'>
            {recipes.map(recipe => <RecipeCard recipe={recipe}/>)}
        </div>
    )
}
